export const PAGE_TYPE_AUTH = 'AUTH';
export const PAGE_TYPE_LOGIN = 'LOGIN';
export const PAGE_TYPE_LOST_PASSWORD = 'LOST_PASSWORD';
export const PAGE_TYPE_APPROVE = 'APPROVE';
export const PAGE_TYPE_REGISTER = 'REGISTER';
